import { getOrganBadgeImage } from '#assets/images/gutBodyConnections/badges';
import { toImageSrc } from '#helpers/imageSrc';
import type {
  GutBodyConnectionsColorVariant,
  GutBodyConnectionsOrgan,
} from '@repo/types';
import { getAgeGroup } from '@repo/utils';
import c from 'classnames';
import styles from './GutBodyConnectionsOrganBadge.module.css';

export type GutBodyConnectionsOrganBadgeProps = {
  organ: GutBodyConnectionsOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  /** The body map's `colorVariant`, so badge and body always agree. */
  colorVariant?: GutBodyConnectionsColorVariant;
  /** Lands on the circle, e.g. to resize it where the PDF headings crop smaller. */
  className?: string;
};

/**
 * An organ as the design file's own icon — one circle per organ and flag level,
 * background drawn in. Decorative: every use sits beside the organ's name.
 */
export function GutBodyConnectionsOrganBadge({
  organ,
  age,
  pregnant,
  colorVariant,
  className,
}: GutBodyConnectionsOrganBadgeProps) {
  const src = getOrganBadgeImage({
    lookupCode: organ.lookup_code,
    flagLevel: organ.flag_level,
    ageGroup: getAgeGroup(age),
    pregnant,
    colorVariant,
  });

  const classNames = c(
    styles.badge,
    styles[colorVariant ?? organ.flag_level],
    className,
  );

  // `oral` has no icon, so the background colour alone holds the row's geometry.
  if (!src) return <span className={classNames} />;

  return <img src={toImageSrc(src)} alt='' className={classNames} />;
}

export default GutBodyConnectionsOrganBadge;
